import React, { useEffect, useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import * as FooterCSS from './css/footer.module.css';

const dataQuery = graphql`
  query {
    common: commonJson {
      footer {
        links {
          title
          url
        }
        copyright
      }
    }
  }
`;

const TheLink = ({ label, href, icon }) => {
  return (
    <>
      <a href={href} target="_blank" rel="noopener noreferrer">
        {label}
      </a>
      {icon && <img className={FooterCSS.icon} src={icon} alt="" />}
    </>
  );
};

const Footer = () => {
  const [privacyLinks, setPrivacyLinks] = useState([]);
  const { common } = useStaticQuery(dataQuery);

  useEffect(() => {
    fetch('/privacy', { cache: 'no-store' })
      .then((r) => r.json())
      .then((data) => {
        const footerLinks = [];

        for (const item_name of data.footerSequence) {
          const links = data.links[item_name];

          if (item_name == 'terms_and_privacy') {
            footerLinks.push([
              <TheLink label="Terms" href={links.urls.terms_link} />,
              ' and ',
              <TheLink label="Privacy Policy" href={links.urls.privacy_link} />,
            ]);
            continue;
          }

          footerLinks.push(
            <TheLink
              label={links.label}
              href={links.url}
              icon={links.showPrivacyControlIcon ? links.icon : undefined}
            />
          );
        }

        setPrivacyLinks(footerLinks);
      })
      .catch(() => {});
  }, []);

  return (
    <footer>
      <div className="container text-center">
        <ul className={FooterCSS.list}>
          {privacyLinks.map((item, idx) => (
            <li key={idx} className={FooterCSS.listItem}>
              {item}
            </li>
          ))}
          <li className={FooterCSS.copyright}>{common.footer.copyright}</li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
